// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"style_cardImage__n_JVZ"};